var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudComputing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#F0F9FF",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#CFE3FF",
    rx: 15.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004BAD",
    d: "M21.442 11.302c-.289 0-.577.02-.863.058a4.966 4.966 0 0 0-2.366-.411 5.915 5.915 0 0 0-11.164 2.343 4.443 4.443 0 0 0-2.116 1.476 4.58 4.58 0 0 0-.975 2.81l-.005.15v.026a3.47 3.47 0 0 0 3.484 3.485h8.483a6.504 6.504 0 0 0 5.522 3.075c3.59 0 6.51-2.916 6.51-6.506 0-3.59-2.92-6.506-6.51-6.506Zm-14.005 8.99a2.523 2.523 0 0 1-2.538-2.537l.005-.157v-.012c.001-.81.273-1.595.772-2.232a3.478 3.478 0 0 1 1.94-1.237.475.475 0 0 0 .368-.463 4.969 4.969 0 0 1 9.513-2.008.473.473 0 0 0 .498.277 4.058 4.058 0 0 1 .75-.035 6.505 6.505 0 0 0-3.815 5.915 6.375 6.375 0 0 0 .5 2.489H7.437Zm14.005 3.085a5.564 5.564 0 1 1 5.564-5.564 5.57 5.57 0 0 1-5.564 5.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004BAD",
    d: "M21.75 15.285a.473.473 0 0 0-.66 0l-1.805 1.75a.474.474 0 0 0 .316.813.46.46 0 0 0 .33-.133l.992-.972V20a.473.473 0 0 0 .947 0v-3.258l1.014.972a.486.486 0 0 0 .679-.01.473.473 0 0 0-.01-.67l-1.804-1.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing1);
export default __webpack_public_path__ + "static/media/cloud-computing 1.f9fab8e2983cee1f66bc5a9a5d10fc9b.svg";
export { ForwardRef as ReactComponent };